export function calcularDisponibilidad(item) {
    let available_stock = 0;
    available_stock = (item.available_quantity + item.presale_stock) - item.safety_stock - item.backorders_stock;
  
    if (available_stock < 0) {
        available_stock = 0;
    }
    
    return available_stock;
}